import { render } from "./VerifyEmailButton.vue?vue&type=template&id=549ded0d"
import script from "./VerifyEmailButton.vue?vue&type=script&lang=js"
export * from "./VerifyEmailButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__